import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const importinvoicemiscApi = createApi({
  reducerPath: "importinvoicemiscApi",
  baseQuery,
  tagTypes: ["ImportInvoice"],

  endpoints: (builder) => ({
    
    // 🔹 GET Misc Charges by ID
    getMiscChargesById: builder.query({
      query: ({ importJobId, importInvoiceId }) =>
        `import/invoice/misc-charges/${importJobId}/${importInvoiceId}`,

      transformResponse: (response) => response?.data,

      providesTags: ["ImportInvoice"],
    }),

    // 🔹 UPSERT (Create + Update)
    upsertMiscCharges: builder.mutation({
      query: ({ importJobId, importInvoiceId, Charges }) => ({
        url: `import/invoice/misc-charges/${importJobId}/${importInvoiceId}`,
        method: "PUT",
        body: { Charges },
      }),
      invalidatesTags: ["ImportInvoice"],
    }),

  }),
});

// Auto-generated hooks
export const {
  useGetMiscChargesByIdQuery,
  useLazyGetMiscChargesByIdQuery,
  useUpsertMiscChargesMutation,
} = importinvoicemiscApi;
